const LeftItems = ({ title }) => {
  return <span className='title'>{title}</span>
}

export default LeftItems
